module.exports = __webpack_public_path__ + "static/media/newOrderNotification.33b57ef0.mp3";